module.exports = __webpack_public_path__ + "img/qrcode_and.298e523a.png";